import React from "react";
import { styled } from "@material-ui/core/styles";

const StartOver = ({ className }) => (
  <svg
    display="block"
    width="16"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_6_194)">
      <path d="M16.2183 0.550537L16.0146 6.83305L9.80341 5.8669" />
      <path d="M2.25182 13.5585C2.01564 13.3128 1.79499 13.0526 1.59117 12.7795C0.96317 11.9372 0.507219 10.9795 0.249357 9.96096C-0.0085045 8.94247 -0.0632279 7.88316 0.0883073 6.84351C0.239843 5.80387 0.594671 4.80423 1.13253 3.90172C1.67039 2.9992 2.38076 2.21149 3.22306 1.58351C6.75987 -1.05398 11.7828 -0.320788 14.4197 3.21475C15.0257 4.02518 15.4717 4.94363 15.734 5.92099L14.1976 6.33341C13.7944 4.83059 12.8586 3.52557 11.5647 2.66142C10.2707 1.79728 8.70678 1.43294 7.16415 1.63628C5.62152 1.83962 4.2054 2.59676 3.17957 3.76669C2.15373 4.93661 1.58814 6.43954 1.58814 7.99552C1.58814 9.55149 2.15373 11.0544 3.17957 12.2243C4.2054 13.3943 5.62152 14.1514 7.16415 14.3548C8.70678 14.5581 10.2707 14.1938 11.5647 13.3296C12.8586 12.4655 13.7944 11.1605 14.1976 9.65765L15.7346 10.0681C15.3678 11.4359 14.6448 12.6818 13.6391 13.6788C12.6335 14.6757 11.3813 15.388 10.0105 15.7428C8.6396 16.0977 7.19913 16.0825 5.83607 15.6988C4.47301 15.315 3.23618 14.5765 2.25182 13.5585Z" />
    </g>
    <defs>
      <clipPath id="clip0_6_194">
        <rect width="16.2183" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default styled(StartOver)({
  fill: "#9E9E9E",
  "&:hover": {
    fill: "#8C8C8C",
  },
});
